<!-- Just a placeholder -->
<!-- A logout route is needed for other canDeactivate guards to work properly -->
<div class="login-wrapper">
  <div class="backdrop-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container">
      <!-- Session Load -->
      <div class="text-center">
        <span><i class="fa fa-circle-o-notch fa-spin fa-fw"></i> Logging out</span>
      </div>
    </div>
  </div>
</div>
